module.exports = __webpack_public_path__ + "static/img/ninja-logo-large.c1cae1b2.png";